import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { domainUrl } from '../../../constants';
import { message } from 'antd';

// Login
export const login = createAsyncThunk('login',
    async (data, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/websiteLogin", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    message.success('Login successful!');
                    localStorage.setItem('token', JSON.stringify(result?.user?.token));
                    localStorage.setItem('refreshToken', result.user.refreshToken);
                    dispatch(loginResponse(result?.user));
                    window.location.href = '/';
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'Login failed');
                dispatch(loginClear());
            });
    }
);

// Signup pro
export const signupPro = createAsyncThunk('signup',
    async (data, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };
        console.log(data)
        fetch(domainUrl + "/registerProfessional", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'Signup successful!');
                    dispatch(loginResponse(result));
                    window.location.href = '/login';
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'Signup failed');
                dispatch(loginClear());
            });
    }
);

// Signup client
export const signupClient = createAsyncThunk('signup',
    async (data, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/registerClient", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'Signup successful!');
                    dispatch(loginResponse(result));
                    window.location.href = '/login';
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'Signup failed');
                dispatch(loginClear());
            });
    }
);

// Refresh Token
export const refreshToken = createAsyncThunk('refreshToken',
    async (_, { dispatch }) => {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            throw 'Refresh token not found';
        }
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ refreshToken }),
        };

        fetch(domainUrl + "/refreshToken", requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                localStorage.setItem('token', JSON.stringify(result?.user?.token));
                dispatch(loginResponse({ token: result.token }));
                return result.token;
            } else {
                throw result.message;
            }
        })
        .catch(error => {
            message.error(error || 'Failed to refresh token');
            dispatch(loginClear());
        });
    }
);

// Forgot Password
export const forgotPassword = createAsyncThunk('forgotPassword',
    async (data, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/forgotPassword", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'OTP sent to your email.');
                    dispatch(forgotPasswordResponse(result));
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'Forgot Password request failed');
                dispatch(loginClear());
            });
    }
);

// OTP Verify
export const otpVerify = createAsyncThunk('otpVerify',
    async (data, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/verifyOtp", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'OTP verified successfully.');
                    dispatch(otpResponse(result?.token));
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'OTP verification failed');
                dispatch(loginClear());
            });
    }
);

// Reset Password
export const resetPassword = createAsyncThunk('resetPassword',
    async ({data,navigate}, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/resetPassword", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'Password reset successfully.');
                    navigate('/login')
                    dispatch(resetResponse(result));
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'Password reset failed');
                dispatch(loginClear());
            });
    }
);

const loginSlice = createSlice({
    name: 'login',
    initialState: {
        data: null,
        loading: false,
        otpToken: null,
        requestState : "request"
    },
    reducers: {
        getting: state => {
            state.loading = true;
            state.data = null;
        },
        loginResponse: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        forgotPasswordResponse: (state, action) => {
            state.data = action.payload;
            state.requestState = "otp"
            state.loading = false;
        },
        otpResponse: (state, action) => {
            state.otpToken = action.payload;
            state.requestState = "reset"
            state.loading = false;
        },
        
        loginClear: state => {
            state.data = null
            state.loading = false
        },
        resetResponse: (state, action) => {
            state.data = action.payload;
            state.loading = false;
            state.token = null
        },
    },
    extraReducers: builder => {
        builder
            .addCase(refreshToken.fulfilled, (state, action) => {
                state.data.token = action.payload;
            });
    },
});

export const { getting, loginResponse, loginClear, otpResponse ,resetResponse, forgotPasswordResponse } = loginSlice.actions;
export default loginSlice.reducer;
